<template>
    <aside class="banner banner--browser">
        <p>Please update your browser to edit content. <UpdateBrowserButton /></p>
    </aside>
</template>

<script>
export default {
    created () {
        document.querySelector('body').style.paddingTop = '50px'
    },

    beforeDestroy() {
        document.querySelector('body').style.paddingTop = null
    },
}
</script>

